/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@mui/styles';
import { Button, Card, CardContent, Container } from '@mui/material';
import { Link } from 'react-router-dom'


const styles = makeStyles(theme => ({
    root: {
        marginTop: '100px!important',
        marginBottom: '200px!important',
        background: `#2c2d2eb0!important`,
        transform: 'skewY(-9deg)'
    },
    video: {
        transform: 'skewY(9deg)'

    }
}));


const YtVideo = () => {
    const classes = styles();

    return (
        <>
            <Grid container spacing={4} className={classes.root}>
                <Grid item xs={12} sm={6} md={6} className={classes.video}>
                    <div className="video-responsive" style={{ margin: "50px" }}>
                        <iframe width="300px" height="400px" src="https://www.youtube.com/embed/A_KvyQ8YqSo"
                            title="WELCOME TO THERAYTEK" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} className={classes.video}>
                    <Typography color="primary" style={{ textAlign: "center", marginTop: '200px', fontSize: '3em' }}>THERAYTEK</Typography>
                    <Typography style={{ textAlign: "center", marginTop: '50px', fontSize: '2em', color: "white" }}>We Explore Possibilities And Strive For Excellence</Typography>
                    <Button
                        component={Link}
                        to="/contact-us"
                        variant="contained"
                        className="AlignCenter"
                        color="secondary"

                        style={{ marginTop: '50px' }}
                    >
                        <Typography variant="h2" >   Contact Us</Typography>


                    </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={6} className={classes.video} >
                    <Typography style={{ textAlign: "center", marginTop: '30px', padding: '30px', fontSize: '2em', color: "white" }}>
                        We are enthusiastic group of people with the experience
                        to satisfy the needs of your idea and deliver best results </Typography>
                    <Button
                        component={Link}
                        to="/contact-us"
                        variant="contained"
                        className="AlignCenter"
                        color="secondary"
                        style={{ marginTop: '50px' }}
                    >
                        <Typography variant="h2" >   Contact Us</Typography>


                    </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={6} className={classes.video}>
                    <div className="video-responsive" style={{ margin: "80px" }}>
                    <iframe width="1904" height="792" src="https://www.youtube.com/embed/qw9k4al7B9U" title="THERAYTEK : who are we" frameborder="0"
                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                       
                    </div>
                </Grid>
            </Grid>

        </>
    );
}



export default YtVideo;